<!--/*
 * Copyright (c) 2020 The Awareness Company. All rights reserved. 
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */ -->
<template>
<div >
  <Dashboard v-if="$vuetify.breakpoint.lgAndUp" ref="Dashboard" />
  <DashboardMobile v-else ref="DashboardMobile" />

  <v-dialog v-model="dialogClosure" fullscreen>
      <v-card>
        <v-card-title
          class="title purple darken-1 white--text"
        ></v-card-title>
        <v-card-text>
          <div class="title pt-5">
            <div class="pb-3">Hi there.</div>
            You’re here looking for updated, accurate stats of the Covid-19 pandemic in South Africa. The thing is, so are we.
          </div>
          <div class="body-1 mt-5">
            After careful consideration, we’re sad to let you know that this site will no longer be available after 20 February 2022.
            <br />
            <br />Just like most of South Africa, we rely on the nightly tweets from the Department of Health to get the latest stats. We run an image recognition AI model to extract the stats from the tweeted picture. Unfortunately, the continuously inconsistent data provided means our dashboard is now unreliable. And so we have made the difficult decision to shut down health.hydra.africa.
            <br />
            <br />For national stats, our Covid-19 Awareness for Africa dashboard, developed in partnership with the UN, is still updated daily:
            <div class="mt-3">
              <v-btn class="mr-4" dark small color="purple darken-1" @click="openAfrica">
                <v-icon left>open_in_new</v-icon>View Africa Dashboard
              </v-btn>
            </div>
            <br />Thank you so much for your support over the last two years. When the pandemic hit South Africa, we immediately had the mission to use our data, visualisation and decision support skills to transform publicly available information into useful, easy-to-understand insights for everyone in South Africa. This dashboard was actually developed in 3 days.
            <br />
            <br />We have been overwhelmed by the kind messages of support we received and we’ll continue to develop our Data for Good initiative to make a positive impact in the world.
            <br />
            <br />Stay safe and stay well.
            <br />
            <br />- The Awareness Company
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
import Dashboard from '@/components/Dashboard.vue';
import DashboardMobile from '@/components/DashboardMobile.vue';
import Papa from 'papaparse'

  export default {
    name: 'Home',
    components: {
      Dashboard,
      DashboardMobile
    },
    data: () => ({
      dialogClosure: true
    }),
      created() {
      //get the data and pass to child components
      
      //cases
      this.loadCases()

      //last updated
      this.loadLastUpdated()

      //interventions
      this.loadInterventions()

      //global stats
      this.loadGlobalStats()
      
    },
    methods: {
      loadCases() {
        var self = this

        var d = new Date()
        var url = "data/toupdate/summary.csv"
        url += "?etag=" + d.toISOString()

        Papa.parse(url, {
          download: true,
          header: true,
          skipEmptyLines: true,
          complete: function(results) {
            //pass to components
            if(self.$refs.Dashboard) {
              self.$refs.Dashboard.loadCases(results.data)
            }
            else {
                self.$refs.DashboardMobile.loadCases(results.data)
            }       
          }
        })
      },
      loadLastUpdated() {
        var self = this

        var d = new Date()
        var url = "data/toupdate/news.csv"
        url += "?etag=" + d.toISOString()

        Papa.parse(url, {
          download: true,
          header: true,
          skipEmptyLines: true,
          complete: function(results) {
            //pass to components
            if(self.$refs.Dashboard) {
              self.$refs.Dashboard.loadLastUpdated(results.data)
            }
            else {
                self.$refs.DashboardMobile.loadLastUpdated(results.data)
            }        
          }
        })
      },
      loadInterventions() {
        var self = this

        var d = new Date()
        var url = "data/toupdate/interventions.csv"
        url += "?etag=" + d.toISOString()

        Papa.parse(url, {
          download: true,
          header: true,
          skipEmptyLines: true,
          complete: function(results) {
            //pass to components
            if(self.$refs.Dashboard) {
              self.$refs.Dashboard.loadInterventions(results.data)
            }
            else {
                self.$refs.DashboardMobile.loadInterventions(results.data)
            }             
          }
        })
      },
      loadGlobalStats() {
        var self = this

        //get confirmed
        self.loadGlobalConfirmed(function(confirmedData){

          //get continents
          self.loadContinents(function(continents){

            //pass to components
            if(self.$refs.Dashboard) {
              self.$refs.Dashboard.loadGlobalStats(confirmedData, continents)
            }
            else {
                self.$refs.DashboardMobile.loadGlobalStats(confirmedData, continents)
            }     
          })
        })
      },
      loadContinents(cb) {
        var self = this

        var d = new Date()
        var url = "data/geo/continents.csv"
        url += "?etag=" + d.toISOString()

        Papa.parse(url, {
          download: true,
          header: true,
          skipEmptyLines: true,
          complete: function(results) {
            cb(results.data)
          }
        })
      },
      loadGlobalConfirmed(cb) {
        var self = this

        var d = new Date()
        var url = "data/toupdate/time_series_covid19_confirmed_global.csv"
        url += "?etag=" + d.toISOString()

        Papa.parse(url, {
          download: true,
          //header: true,
          skipEmptyLines: true,
          complete: function(results) {
            cb(results.data)
          }
        })
      },
      resize() {
        this.$refs.Map.resize()
      },
      openAfrica() {
        window.location.href = './africa';

        //post the GA
        gtag('event', 'africa', {
          'event_category' : 'open',
          'send_to': 'UA-161523063-1'
        });
      },
    }
  }
</script>
